export default __webpack_public_path__ + "static/media/fff805d8aee0c0da583801474bf9a43c1581618091698.3c8ff8fd.webp";